import React from 'react';
import { usePozadi, useEsc } from './modalHooks';

export default function ConfirmModal({ message, onConfirm, onCancel, confirmLabel = 'Potvrdit', danger = false, zIndex = 1000 }) {
  const pozadi = usePozadi(onCancel);
  useEsc(onCancel);
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.4)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex,
    }} {...pozadi}>
      <div style={{
        background: '#fff', borderRadius: '12px', padding: '28px',
        maxWidth: '420px', width: '90%',
        boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
      }}>
        <p style={{ color: '#333', fontSize: '15px', margin: '0 0 24px', lineHeight: 1.6 }}>
          {message}
        </p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button onClick={onCancel} style={{
            padding: '10px 20px', border: '1px solid #9ca3af', borderRadius: '6px',
            background: 'transparent', color: '#555', cursor: 'pointer', fontSize: '14px',
          }}>
            Zrušit
          </button>
          <button onClick={onConfirm} style={{
            padding: '10px 20px', border: 'none', borderRadius: '6px',
            background: danger ? '#ef4444' : '#3ab54a',
            color: 'white', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold',
          }}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
